import * as React from "react";
const IconArchive = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M56.7 4.3H7.3c-3.1 0-5.6 2.5-5.6 5.6V16c0 2.9 2.2 5.3 5.1 5.5v32.1c0 3.4 2.7 6.1 6.1 6.1H51c3.4 0 6.1-2.7 6.1-6.1V21.5c2.8-.2 5.1-2.6 5.1-5.5V9.9c.1-3.1-2.4-5.6-5.5-5.6M51 55.2H13c-.9 0-1.6-.7-1.6-1.6V21.5h41.3v32.1c0 .9-.8 1.6-1.7 1.6M57.8 16c0 .6-.5 1.1-1.1 1.1H7.3c-.6 0-1.1-.5-1.1-1.1V9.9c0-.6.5-1.1 1.1-1.1h49.4c.6 0 1.1.5 1.1 1.1z" />
    <path d="M40.2 29.8H23.8c-2.3 0-4.3 1.9-4.3 4.3v6.2c0 2.3 1.9 4.3 4.3 4.3h16.4c2.3 0 4.3-1.9 4.3-4.3V34c-.1-2.3-2-4.2-4.3-4.2m-.3 10.1H24.1v-5.7H40v5.7z" />
  </svg>
);
export default IconArchive;
